import { gql } from '@apollo/client';

export const TRIGGER_PRICE_SYNC_NOW = gql(/* GraphQL */ `
    mutation TriggerPriceSyncNow {
        triggerPriceSyncNow {
            processed
        }
    }
`);

export const RETRY_PRICE_SYNC_QUEUE_ROW = gql(/* GraphQL */ `
    mutation RetryPriceSyncQueueRow($queueId: String!) {
        retryPriceSyncQueueRow(queueId: $queueId) {
            id
            status
        }
    }
`);

export const ENQUEUE_PRODUCT_FOR_PRICE_SYNC = gql(/* GraphQL */ `
    mutation EnqueueProductForPriceSync($productId: String!) {
        enqueueProductForPriceSync(productId: $productId) {
            productId
            storeNo
            sku
            queueStatus
        }
    }
`);
